/**
 * 应急外教池 - 常量定义
 */

// 星期定义
export const DAYS_OF_WEEK = [
  { key: 'monday', label: '周一' },
  { key: 'tuesday', label: '周二' },
  { key: 'wednesday', label: '周三' },
  { key: 'thursday', label: '周四' },
  { key: 'friday', label: '周五' },
  { key: 'saturday', label: '周六' },
  { key: 'sunday', label: '周日' }
]

// 时段定义 (北京时间17:00-22:00；17:00/17:30 为后加，id 接在 slot8 之后)
export const TIME_SLOTS = [
  { id: 'slot9', label: '17:00', startTime: '17:00', endTime: '17:30' },
  { id: 'slot10', label: '17:30', startTime: '17:30', endTime: '18:00' },
  { id: 'slot1', label: '18:00', startTime: '18:00', endTime: '18:30' },
  { id: 'slot2', label: '18:30', startTime: '18:30', endTime: '19:00' },
  { id: 'slot3', label: '19:00', startTime: '19:00', endTime: '19:30' },
  { id: 'slot4', label: '19:30', startTime: '19:30', endTime: '20:00' },
  { id: 'slot5', label: '20:00', startTime: '20:00', endTime: '20:30' },
  { id: 'slot6', label: '20:30', startTime: '20:30', endTime: '21:00' },
  { id: 'slot7', label: '21:00', startTime: '21:00', endTime: '21:30' },
  { id: 'slot8', label: '21:30', startTime: '21:30', endTime: '22:00' }
]

// 资格认证配置
export const QUALIFICATION_CONFIG = {
  minYearsEmployed: 1,      // 最低入职年限（开课日期起算；以后端 qualified 为准）
  minFillRate: 65,          // 最低上课率(%)
  minBuyoutSlots: 28        // 最低买断时段数
}

/**
 * 获取星期标签
 */
export function getDayLabel(day) {
  const item = DAYS_OF_WEEK.find(d => d.key === day)
  return item ? item.label : ''
}

/**
 * 获取时段标签
 */
export function getSlotLabel(slotId) {
  const item = TIME_SLOTS.find(s => s.id === slotId)
  return item ? item.label : ''
}

/**
 * 计算入职年限
 */
export function getYearsEmployed(hireDate) {
  const hire = new Date(hireDate)
  const now = new Date()
  return (now.getTime() - hire.getTime()) / (1000 * 60 * 60 * 24 * 365)
}

/**
 * 检查老师是否符合资格
 */
export function isTeacherQualified(teacher, config = QUALIFICATION_CONFIG) {
  const yearsEmployed = getYearsEmployed(teacher.hireDate)
  // 后端 fillRate 为 0~1 小数；兼容历史百分数
  const fillPct = teacher.fillRate <= 1 ? teacher.fillRate * 100 : teacher.fillRate
  return (
    yearsEmployed >= config.minYearsEmployed &&
    fillPct >= config.minFillRate &&
    teacher.buyoutSlots >= config.minBuyoutSlots
  )
}

/**
 * 获取老师的时段数量
 */
export function getTeacherSlotCount(teacherId, availability, status = 'all') {
  const teacherAvail = availability.find(a => a.teacherId === teacherId)
  if (!teacherAvail) return 0
  
  if (status === 'all') {
    return teacherAvail.slots.length
  }
  return teacherAvail.slots.filter(s => s.status === status).length
}

/**
 * 获取热力图等级 (0-5)
 */
export function getHeatLevel(count) {
  if (count === 0) return 0
  if (count === 1) return 1
  if (count === 2) return 2
  if (count === 3) return 3
  if (count === 4) return 4
  return 5
}

/**
 * 获取性别标签
 */
export function getGenderLabel(gender) {
  return gender === 'male' ? '男' : '女'
}

/**
 * 获取口音标签
 */
export function getAccentLabel(accent) {
  return accent === 'american' ? '美音' : '英音'
}



// WEBPACK FOOTER //
// ./src/utils/constants.js